import React, { useState } from 'react';
import meterFunctionality from '../../assets/meter/meter-functionality.jpg';

// Approximate coordinates on the 1774x887 source image for each labeled
// element, used to animate signal-flow dots along the same paths the image
// already draws in static blue — the photo itself is untouched, this is a
// transparent SVG layer on top of it.
const METER = { x: 890, y: 520 };
const NODES = [
  { key: 'grid', label: 'Grid Supply', pos: { x: 460, y: 790 } },
  { key: 'router', label: 'Router', pos: { x: 565, y: 430 } },
  { key: 'cloud', label: 'GRIDx Cloud', pos: { x: 950, y: 130 } },
  { key: 'geyser', label: 'Geyser Control', pos: { x: 1290, y: 300 } },
  { key: 'demand', label: 'Demand Management', pos: { x: 1290, y: 500 } },
  { key: 'home', label: 'Home & Appliances', pos: { x: 1500, y: 790 } },
];

const STATES = [
  { key: 'normal', label: 'Normal' },
  { key: 'healthy', label: 'Healthy' },
  { key: 'alert', label: 'Alert' },
];

const SignalOverlay = ({ status }) => (
  <svg
    className={`hiw-overlay hiw-overlay--${status}`}
    viewBox="0 0 1774 887"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    {NODES.map((n, i) => (
      <line
        key={n.key}
        x1={METER.x} y1={METER.y} x2={n.pos.x} y2={n.pos.y}
        className="hiw-overlay__pulse"
        style={{ animationDelay: `${i * 0.5}s` }}
      />
    ))}
  </svg>
);

const HowItWorks = () => {
  const [status, setStatus] = useState('normal');

  return (
    <section className="gh-section hiw" id="how-it-works">
      <div className="gh-section__inner">
        <span className="eyebrow">How the GRIDx meter works</span>
        <h2 className="gh-section__title">One meter. A complete energy network.</h2>
        <p className="gh-section__sub">
          The GRIDx meter sits between the grid and the home — measuring supply,
          communicating with the GRIDx Cloud, and coordinating the devices connected
          to it.
        </p>

        <div className="hiw__status" role="group" aria-label="Network status demo">
          <span className="hiw__status-label">Network status:</span>
          {STATES.map((s) => (
            <button
              key={s.key}
              className={`hiw__status-btn hiw__status-btn--${s.key} ${status === s.key ? 'is-active' : ''}`}
              onClick={() => setStatus(s.key)}
              aria-pressed={status === s.key}
            >
              {s.label}
            </button>
          ))}
        </div>

        <div className="hiw__diagram">
          <img
            src={meterFunctionality}
            alt="Diagram of the GRIDx meter connecting grid supply, router, geyser control, demand management and home appliances to the GRIDx Cloud Platform"
            className="hiw__diagram-img"
          />
          <SignalOverlay status={status} />
        </div>

        <div className="hiw__legend">
          {NODES.map((n) => (
            <div key={n.key} className="hiw__legend-item">
              <span className="hiw__legend-dot" />
              {n.label}
            </div>
          ))}
        </div>

        <details className="hiw__video">
          <summary>Watch the GRIDx smart meter demo</summary>
          <div className="hiw__video-wrapper">
            <iframe
              src="https://www.youtube.com/embed/D-f2QchGfj8"
              title="GRIDx Smart Meter Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </details>
      </div>
    </section>
  );
};

export default HowItWorks;
